angular.module('galilai.creator').controller('ProductTextController', function ($timeout, $scope, $http, api, $rootScope) {

    $scope.loading = false
    $scope.current = null
    $scope.view = {
        texts: '',
    }

    $rootScope.$on('media.item.show', function(event, data) {
        if (!data || data.kind !== 'product-text') {
            return
        }
        $scope.current = data
        angular.element('#product-text-modal').modal('show')
    })


    $scope.save = function()  {
        let baseProduct = {}
        if (getCurrentCurrency()) {
            baseProduct.currency = getCurrentCurrency()
            baseProduct.country = getCurrentCountry()
        }

        baseProduct.projectId = $scope.current.projectId
        baseProduct.collection = $scope.current.collection
        // Split texts by new line and each create product
        let texts = $scope.view.texts.split('\n').map(t => t.trim()).filter(t => t.length > 0)
        if (texts.length === 0) {
            showError(gettext('error.fill_required_fields'))
            return
        }
        // Remove from each line start
        texts = texts.map(t => {
            if (t.startsWith('-')) {
                return t.substring(1).trim()
            }
            return t
        })
        // Use promises (allow to fail some without failing all)
        $scope.loading = true
        let promises = texts.map(t => {
            let data = Object.assign({}, baseProduct, {
                name: t,
            })
            return api.createProduct(data).then(function(response) {
                if (!response || !response.data || !response.data._id) {
                    return Promise.reject(new Error(gettext('error.generic')))
                }
                return Promise.resolve()
            })
            .catch(function(error) {
                return Promise.reject(error)
            })
        })
        Promise.allSettled(promises).then(results => {
            let successCount = results.filter(r => r.status === 'fulfilled').length
            let failCount = results.filter(r => r.status === 'rejected').length
            if (successCount > 0) {
                $rootScope.$emit('media.item.created', {
                    source: $scope.current.source,
                    kind: 'product',
                })
                angular.element('#product-text-modal').modal('hide')
            } else {
                showError(gettext('error.generic'))
            }
        }).catch(e => {
            showError(gettext('error.generic'))
        }).finally(() => {
            $scope.loading = false
        })
    }

})